const TIPOS = {
  poste: 'Poste',
  postemadeira: 'Poste de madeira',
  trafotrif: 'Trafo trifásico',
  trafomono: 'Trafo monofásico',
  trifasica: 'Trifásica',
  tronco: 'Tronco',
  bt: 'BT',
  equipamentonf: 'Equipamento',
  protecao: 'Proteção',
  'equipamento na': 'Chave NA',
  rotulo: 'Rótulo',
};

const ACESSO = {
  facil: 'Fácil',
  medio: 'Médio',
  dificil: 'Difícil',
};

const IGNORAR = {
  kml_style: true,
  elevation: true,
  length: true,
  bearing: true,
  sinuosity: true,
};

function semAcento(valor) {
  return String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function limparLinha(valor) {
  return String(valor || '').replace(/[ \t]+/g, ' ').trim();
}

function srcSeguro(url) {
  const texto = String(url || '').trim();
  if (!texto || /^(javascript|data):/i.test(texto)) return '';
  return texto;
}

function fotosDoHtml(html) {
  const fotos = [];
  const marcas = String(html || '').matchAll(/<img\b[^>]*>/gi);
  Array.from(marcas).forEach((marca) => {
    const src = marca[0].match(/\bsrc\s*=\s*["']([^"']+)["']/i);
    const seguro = src && srcSeguro(src[1]);
    if (seguro) fotos.push(seguro);
  });
  return fotos;
}

function textoDoHtml(html) {
  return String(html || '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|tr|li|h[1-6])>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
}

const VEICULO = {
  true: 'Sim',
  false: 'Não',
  sim: 'Sim',
  nao: 'Não',
};

function classeDoRotulo(rotulo) {
  const chave = semAcento(rotulo);
  if (chave === 'nsmp id' || chave === 'nsmpid') return 'id';
  if (chave === 'nsmp') return 'nsmp';
  if (chave === 'tipo de servico') return 'tipo';
  if (chave === 'motivo') return 'motivo';
  if (chave === 'observacao' || chave.startsWith('observacao')) return 'observacao';
  if (chave.includes('programada')) return 'programada';
  if (chave.includes('nova') && chave.includes('nsmp')) return 'nova';
  if (chave === 'servico') return 'servico';
  if (chave === 'prioridade') return 'prioridade';
  if (chave.includes('equipe')) return 'equipe';
  if (chave === 'acesso') return 'acesso';
  if (chave.includes('acesso') && chave.includes('veiculo')) return 'veiculo';
  if (chave.includes('poste') || chave === 'altura' || chave === 'capacidade') return 'poste';
  return 'outro';
}

function valorDoCampo(rotulo, valor) {
  const classe = classeDoRotulo(rotulo);
  const chave = semAcento(valor);
  if (classe === 'acesso') return ACESSO[chave] || valor;
  if (classe === 'veiculo') return VEICULO[chave] || valor;
  return valor;
}

export function rotuloPrioridade(valor) {
  const texto = String(valor || '').trim();
  if (!texto) return '';
  if (/^\d+$/.test(texto)) return `P${texto}`;
  return texto;
}

function frasesDeServico(valor) {
  return String(valor || '')
    .split(/(?=Serviço\s*:)/i)
    .map((pedaco) => pedaco.trim())
    .filter(Boolean)
    .map((pedaco) => {
      const corpo = pedaco.replace(/^Serviço\s*:\s*/i, '').trim();
      const partes = corpo.match(/^(.*?)\s+-\s+Prioridade\s*:\s*(.*?)\s+-\s+Descrição\s*:\s*([\s\S]*)$/i);
      if (!partes) return { nome: corpo, prioridade: '', descricao: '' };
      return {
        nome: partes[1].trim(),
        prioridade: partes[2].trim(),
        descricao: partes[3].trim(),
      };
    })
    .filter((item) => item.nome);
}

function campoDe(rotulo, valor, cheia) {
  return { rotulo, valor, cheia: Boolean(cheia) };
}

function montarSecoes(nome, campos) {
  const porClasse = {};
  campos.forEach((campo) => {
    const classe = classeDoRotulo(campo.rotulo);
    if (!porClasse[classe]) porClasse[classe] = [];
    porClasse[classe].push(campo);
  });
  const idSolto = (porClasse.nsmp || []).find((campo) => /^[0-9a-f-]{36}$/i.test(campo.valor));
  const nsmpId = ((porClasse.id || [])[0] || idSolto || {}).valor || '';
  (porClasse.nsmp || []).forEach((campo) => {
    if (campo === idSolto) return;
    if (!porClasse.programada) porClasse.programada = [];
    porClasse.programada.push(campo);
  });
  const servicos = (porClasse.servico || []).flatMap((campo) => frasesDeServico(campo.valor));
  const temServico = Boolean(
    nsmpId
    || (porClasse.tipo || []).length
    || (porClasse.programada || []).length
    || (porClasse.nova || []).length
    || servicos.length
  );
  if (!temServico) {
    return {
      titulo: nome,
      nsmpId: '',
      servico: false,
      digitacao: [],
      servicos: [],
      servicoCampos: [],
      poste: [],
    };
  }
  const digitacao = [];
  (porClasse.tipo || []).forEach((campo) => digitacao.push(campoDe('Tipo de serviço', campo.valor, true)));
  (porClasse.programada || []).forEach((campo) => digitacao.push(campoDe('NSMP programada', campo.valor, false)));
  (porClasse.nova || []).forEach((campo) => digitacao.push(campoDe('NSMP nova', campo.valor, false)));
  (porClasse.motivo || []).forEach((campo) => digitacao.push(campoDe('Motivo', campo.valor, true)));
  (porClasse.observacao || []).forEach((campo) => digitacao.push(campoDe('Observação', campo.valor, true)));
  const servicoCampos = [];
  (porClasse.equipe || []).forEach((campo) => servicoCampos.push(campoDe('Equipe indicada', campo.valor, false)));
  if (!servicos.some((item) => item.prioridade)) {
    (porClasse.prioridade || []).forEach((campo) => servicoCampos.push(campoDe('Prioridade', campo.valor, false)));
  }
  (porClasse.outro || []).forEach((campo) => servicoCampos.push(campoDe(campo.rotulo, campo.valor, false)));
  const poste = [];
  (porClasse.poste || []).forEach((campo) => poste.push(campoDe(campo.rotulo, campo.valor, false)));
  (porClasse.acesso || []).forEach((campo) => poste.push(campoDe('Acesso', campo.valor, false)));
  (porClasse.veiculo || []).forEach((campo) => poste.push(campoDe('Acesso de veículo', campo.valor, false)));
  const titulo = nome ? `Serviço ${nome}` : 'Serviço';
  return {
    titulo,
    nsmpId,
    servico: true,
    digitacao,
    servicos,
    servicoCampos,
    poste,
  };
}

function rotuloDoTipo(bruto) {
  const chave = semAcento(bruto);
  if (!chave) return '';
  return TIPOS[chave] || String(bruto || '').trim();
}

export function htmlDaDescricao(el) {
  if (!el) return '';
  if (el.children && el.children.length) return el.innerHTML || '';
  return el.textContent || '';
}

export function fichaDoHtml(nome, html, opcoes) {
  const tituloNome = limparLinha(nome);
  const linha = Boolean(opcoes && opcoes.linha);
  const fotos = fotosDoHtml(html);
  const textos = [];
  const campos = [];
  let tipoBruto = '';
  textoDoHtml(html).split('\n').forEach((bruta) => {
    const linhaTexto = limparLinha(bruta);
    if (!linhaTexto) return;
    const marcado = linhaTexto.match(/^([A-Za-z][A-Za-z0-9_ ]{0,40})\s*=\s*(.*)$/);
    if (marcado) {
      const chave = semAcento(marcado[1]);
      if (chave === 'kml_style') tipoBruto = limparLinha(marcado[2]);
      if (IGNORAR[chave]) return;
    }
    if (/^\d{2}-\d+:\d+$/.test(linhaTexto)) {
      campos.push({ rotulo: 'Código', valor: linhaTexto });
      return;
    }
    const campo = linhaTexto.match(/^([^:]{1,40}):\s*(.+)$/);
    if (campo) {
      const rotulo = limparLinha(campo[1]);
      const valor = limparLinha(campo[2]);
      if (!rotulo || !valor || IGNORAR[semAcento(rotulo)]) return;
      campos.push({ rotulo, valor: valorDoCampo(rotulo, valor) });
      return;
    }
    if (tituloNome && linhaTexto === tituloNome) return;
    textos.push(linhaTexto);
  });
  const tipo = rotuloDoTipo(tipoBruto);
  const rotulo = semAcento(tipoBruto) === 'rotulo';
  const secoes = montarSecoes(tituloNome, campos);
  const titulo = secoes.servico
    ? secoes.titulo
    : (tituloNome || tipo || (linha ? 'Trecho' : 'Estrutura'));
  return {
    abrir: !rotulo,
    titulo,
    kmlStyle: tipoBruto,
    nsmpId: secoes.nsmpId,
    servico: secoes.servico,
    tipo: !secoes.servico && tipo && tipo !== titulo ? tipo : '',
    digitacao: secoes.digitacao,
    servicos: secoes.servicos,
    servicoCampos: secoes.servicoCampos,
    poste: secoes.poste,
    textos: secoes.servico ? [] : textos,
    campos: secoes.servico ? [] : campos,
    fotos,
  };
}
